import React, { useState, useEffect, FunctionComponent, CSSProperties } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailMainContentProps as Props } from './types';

export const Component: FunctionComponent<Props> = (props) => {
  const [backgroundStyle, setBackgroundStyle] = useState<CSSProperties>({ backgroundImage: '' });

  useEffect(() => {
    const url = props.coverImg || props.coverNoImg;
    setBackgroundStyle({ backgroundImage: `url(${url})` });
  }, [props.coverImg, props.coverNoImg]);

  return <Presentation backgroundStyle={backgroundStyle} />;
};
